import styled from "styled-components";
import { IFrameWrapper } from "../IFrame/IFrame.styled";

export const JWTIFrameWrapper = styled(IFrameWrapper)`
  padding: 20px 32px;

  & > * {
    margin: 0;
  }
`;
